import { useState, useEffect } from 'react';

export interface NetworkStatus {
  isOnline: boolean;
  isLowBandwidth: boolean;
  saveData: boolean;
  effectiveType: string; // '4g' | '3g' | '2g' | 'slow-2g'
}

export const useNetworkStatus = (): NetworkStatus => {
  const [status, setStatus] = useState<NetworkStatus>(() => {
    const isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;
    const conn = (navigator as any)?.connection || (navigator as any)?.mozConnection || (navigator as any)?.webkitConnection;
    const saveData = conn?.saveData || false;
    const effectiveType = conn?.effectiveType || '4g';
    const isLowBandwidth = saveData || effectiveType === '2g' || effectiveType === 'slow-2g' || effectiveType === '3g';

    return { isOnline, isLowBandwidth, saveData, effectiveType };
  });

  useEffect(() => {
    const updateOnlineStatus = () => {
      const conn = (navigator as any)?.connection;
      const saveData = conn?.saveData || false;
      const effectiveType = conn?.effectiveType || '4g';
      const isLowBandwidth = saveData || effectiveType === '2g' || effectiveType === 'slow-2g' || effectiveType === '3g';

      setStatus({
        isOnline: navigator.onLine,
        isLowBandwidth,
        saveData,
        effectiveType,
      });
    };

    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    const conn = (navigator as any)?.connection;
    if (conn) {
      conn.addEventListener('change', updateOnlineStatus);
    }

    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
      if (conn) {
        conn.removeEventListener('change', updateOnlineStatus);
      }
    };
  }, []);

  return status;
};
